import { EXISTING_FIELDS } from "../../constant/configurationConstant";
import {EXCLUDE_FIELD, MANUAL_FIELD, NONE_FIELD } from "../../constant/Stepper";
import { MATCH_ALPHABETIC } from "../../utils/Regex";

export const formatNumberWithCommas = (number?: any) => {
  if (typeof number !== "undefined" && number !== null) {
    return number.toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return ""; // Return an empty string if number is undefined or null
};
export const changeCurrencyToNumber = (number: any): any => {
  if (typeof number !== "undefined" && number !== null) {
    const value = Number(number.toLocaleString().replace(/,/g, ""));
    return value;
  }
  return ""; // Return an empty string if number is undefined or null
};

export const validateInput = (inputStr: string) => {
  // Regular expression to match alphabetic character at the beginning
  const pattern = MATCH_ALPHABETIC;

  // Check if input matches the pattern
  if (pattern.test(inputStr)) {
    return true;
  } else {
    return false;
  }
}

export const getOptionList = (configData: any, inputField: any) => {
  const { optionField, configField, configId, hasExcludeOption } = inputField;
  if (!configData[configId] || !configField) return [MANUAL_FIELD];
  const configFieldData = configData[configId][configField][optionField] ?? [];
  let result = [MANUAL_FIELD, ...configFieldData];
  
  if (hasExcludeOption) {
    result = [NONE_FIELD, EXCLUDE_FIELD, ...result];
  }
  
  // if (hasNAOption) {
  //   result = [NA_FIELD, ...result];
  // }
  return result;
  
}
export const INDUSTRY_OPTIONS = [
  {
    id: "financialservices",
    label: "Financial Services",
    name: "Financial Services",
  },
  {
    id: "healthcare",
    name: "Healthcare",
    label: "healthcare",
  },
  {
    id: "retail",
    name: "Retail",
    label: "retail",
  },
  {
    id: "government",
    name: "Government and Public Sector",
    label: "government",
  },
  {
    id: "defense",
    name: "Defense and Intelligence",
    label: "defense",
  },
  {
    id: "pharmaceutical",
    name: "Pharmaceutical",
    label: "pharmaceutical",
  },
  {
    id: "oilandgas",
    name: "Oil and Gas",
    label: "oilandgas",
  },
  {
    id: "mining",
    name: "Mining",
    label: "mining",
  },
  {
    id: "other",
    name: "Other",
    label: "other",
  }
]

export function debounce<F extends (...args: any[]) => void>(func: F, delay: number) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: Parameters<F>) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export const isUpdatedProduct = (
  products: any,
  updatedProducts: number[],
  selectedProduct: number[],
  key: any,
  configId?:any
): boolean => {
  if(configId && configId.id==4){
  
  const productStr = String(products);

  // Case 1: Check against EXISTING_FIELDS
  if (key === EXISTING_FIELDS) {
    const isInSelected = selectedProduct.some((id) =>
      productStr.includes(String(id))
    );
    return !isInSelected;
  }

  // Case 2: Check against NEW_FIELDS (or any other key)
  const isInUpdated = updatedProducts.some((id) =>
    productStr.includes(String(id))
  );
  return !isInUpdated;
}
else{
    return false;
}
};
